/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddExistingCompanyToProcurementDto } from '../models';
// @ts-ignore
import type { CompanyBasicDto } from '../models';
// @ts-ignore
import type { CompanyNameDto } from '../models';
// @ts-ignore
import type { CreateProcurementSupplierDto } from '../models';
// @ts-ignore
import type { FileMetaDataDto } from '../models';
// @ts-ignore
import type { ImportProcurementSuppliersDto } from '../models';
// @ts-ignore
import type { InviteProcurementSuppliersDto } from '../models';
// @ts-ignore
import type { ProcurementControllerGetProcurementSuppliers200Response } from '../models';
// @ts-ignore
import type { ProcurementSupplierHubDto } from '../models';
// @ts-ignore
import type { RegisterProcurementSupplierDto } from '../models';
// @ts-ignore
import type { SupplierRegistrationStatusDto } from '../models';
// @ts-ignore
import type { UpdateProcurementSupplierDto } from '../models';
// @ts-ignore
import type { ValidateProcurementSupplierDto } from '../models';
/**
 * ProcurementApi - axios parameter creator
 * @export
 */
export const ProcurementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddExistingCompanyToProcurementDto} addExistingCompanyToProcurementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerAddExistingCompanyToProcurement: async (addExistingCompanyToProcurementDto: AddExistingCompanyToProcurementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addExistingCompanyToProcurementDto' is not null or undefined
            assertParamExists('procurementControllerAddExistingCompanyToProcurement', 'addExistingCompanyToProcurementDto', addExistingCompanyToProcurementDto)
            const localVarPath = `/api/procurement/suppliers/add-existing-company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addExistingCompanyToProcurementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateProcurementSupplierDto} createProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerCreateProcurementSupplier: async (createProcurementSupplierDto: CreateProcurementSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProcurementSupplierDto' is not null or undefined
            assertParamExists('procurementControllerCreateProcurementSupplier', 'createProcurementSupplierDto', createProcurementSupplierDto)
            const localVarPath = `/api/procurement/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProcurementSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} procurementSupplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerDeleteProcurementSupplier: async (procurementSupplierId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'procurementSupplierId' is not null or undefined
            assertParamExists('procurementControllerDeleteProcurementSupplier', 'procurementSupplierId', procurementSupplierId)
            const localVarPath = `/api/procurement/suppliers/{procurementSupplierId}`
                .replace(`{${"procurementSupplierId"}}`, encodeURIComponent(String(procurementSupplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerExportProcurementSuppliers: async (timezone?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/procurement/suppliers/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timezone !== undefined) {
                localVarQueryParameter['timezone'] = timezone;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetBuyerCompanyName: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('procurementControllerGetBuyerCompanyName', 'companyId', companyId)
            const localVarPath = `/api/procurement/suppliers/{companyId}/public`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetProcurementSupplierHubs: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/procurement/supplier/hubs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetProcurementSuppliers: async (search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/procurement/suppliers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderDirection !== undefined) {
                localVarQueryParameter['orderDirection'] = orderDirection;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProcurementControllerGetSupplierReportsMetaDataFormBaseType} formBaseType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetSupplierReportsMetaData: async (formBaseType: ProcurementControllerGetSupplierReportsMetaDataFormBaseType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formBaseType' is not null or undefined
            assertParamExists('procurementControllerGetSupplierReportsMetaData', 'formBaseType', formBaseType)
            const localVarPath = `/api/procurement/suppliers/supplier-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (formBaseType !== undefined) {
                localVarQueryParameter['formBaseType'] = formBaseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ImportProcurementSuppliersDto} importProcurementSuppliersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerImportProcurementSuppliers: async (importProcurementSuppliersDto: ImportProcurementSuppliersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'importProcurementSuppliersDto' is not null or undefined
            assertParamExists('procurementControllerImportProcurementSuppliers', 'importProcurementSuppliersDto', importProcurementSuppliersDto)
            const localVarPath = `/api/procurement/suppliers/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importProcurementSuppliersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InviteProcurementSuppliersDto} inviteProcurementSuppliersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerInviteProcurementSuppliers: async (inviteProcurementSuppliersDto: InviteProcurementSuppliersDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteProcurementSuppliersDto' is not null or undefined
            assertParamExists('procurementControllerInviteProcurementSuppliers', 'inviteProcurementSuppliersDto', inviteProcurementSuppliersDto)
            const localVarPath = `/api/procurement/suppliers/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteProcurementSuppliersDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterProcurementSupplierDto} registerProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerRegisterProcurementSupplier: async (registerProcurementSupplierDto: RegisterProcurementSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerProcurementSupplierDto' is not null or undefined
            assertParamExists('procurementControllerRegisterProcurementSupplier', 'registerProcurementSupplierDto', registerProcurementSupplierDto)
            const localVarPath = `/api/procurement/suppliers/registration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerProcurementSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} procurementSupplierId 
         * @param {UpdateProcurementSupplierDto} updateProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerUpdateProcurementSupplier: async (procurementSupplierId: string, updateProcurementSupplierDto: UpdateProcurementSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'procurementSupplierId' is not null or undefined
            assertParamExists('procurementControllerUpdateProcurementSupplier', 'procurementSupplierId', procurementSupplierId)
            // verify required parameter 'updateProcurementSupplierDto' is not null or undefined
            assertParamExists('procurementControllerUpdateProcurementSupplier', 'updateProcurementSupplierDto', updateProcurementSupplierDto)
            const localVarPath = `/api/procurement/suppliers/{procurementSupplierId}`
                .replace(`{${"procurementSupplierId"}}`, encodeURIComponent(String(procurementSupplierId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcurementSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateProcurementSupplierDto} validateProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerValidateProcurementSupplier: async (validateProcurementSupplierDto: ValidateProcurementSupplierDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validateProcurementSupplierDto' is not null or undefined
            assertParamExists('procurementControllerValidateProcurementSupplier', 'validateProcurementSupplierDto', validateProcurementSupplierDto)
            const localVarPath = `/api/procurement/suppliers/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateProcurementSupplierDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcurementApi - functional programming interface
 * @export
 */
export const ProcurementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcurementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AddExistingCompanyToProcurementDto} addExistingCompanyToProcurementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerAddExistingCompanyToProcurement(addExistingCompanyToProcurementDto: AddExistingCompanyToProcurementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerAddExistingCompanyToProcurement(addExistingCompanyToProcurementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerAddExistingCompanyToProcurement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateProcurementSupplierDto} createProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerCreateProcurementSupplier(createProcurementSupplierDto: CreateProcurementSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerCreateProcurementSupplier(createProcurementSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerCreateProcurementSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} procurementSupplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerDeleteProcurementSupplier(procurementSupplierId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerDeleteProcurementSupplier(procurementSupplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerDeleteProcurementSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerExportProcurementSuppliers(timezone?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerExportProcurementSuppliers(timezone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerExportProcurementSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerGetBuyerCompanyName(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyNameDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerGetBuyerCompanyName(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerGetBuyerCompanyName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerGetProcurementSupplierHubs(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcurementSupplierHubDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerGetProcurementSupplierHubs(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerGetProcurementSupplierHubs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerGetProcurementSuppliers(search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcurementControllerGetProcurementSuppliers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerGetProcurementSuppliers(search, orderBy, orderDirection, pageNumber, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerGetProcurementSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProcurementControllerGetSupplierReportsMetaDataFormBaseType} formBaseType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerGetSupplierReportsMetaData(formBaseType: ProcurementControllerGetSupplierReportsMetaDataFormBaseType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FileMetaDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerGetSupplierReportsMetaData(formBaseType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerGetSupplierReportsMetaData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ImportProcurementSuppliersDto} importProcurementSuppliersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerImportProcurementSuppliers(importProcurementSuppliersDto: ImportProcurementSuppliersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerImportProcurementSuppliers(importProcurementSuppliersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerImportProcurementSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InviteProcurementSuppliersDto} inviteProcurementSuppliersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerInviteProcurementSuppliers(inviteProcurementSuppliersDto: InviteProcurementSuppliersDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerInviteProcurementSuppliers(inviteProcurementSuppliersDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerInviteProcurementSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterProcurementSupplierDto} registerProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerRegisterProcurementSupplier(registerProcurementSupplierDto: RegisterProcurementSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SupplierRegistrationStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerRegisterProcurementSupplier(registerProcurementSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerRegisterProcurementSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} procurementSupplierId 
         * @param {UpdateProcurementSupplierDto} updateProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerUpdateProcurementSupplier(procurementSupplierId: string, updateProcurementSupplierDto: UpdateProcurementSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerUpdateProcurementSupplier(procurementSupplierId, updateProcurementSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerUpdateProcurementSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ValidateProcurementSupplierDto} validateProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async procurementControllerValidateProcurementSupplier(validateProcurementSupplierDto: ValidateProcurementSupplierDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyBasicDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.procurementControllerValidateProcurementSupplier(validateProcurementSupplierDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcurementApi.procurementControllerValidateProcurementSupplier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcurementApi - factory interface
 * @export
 */
export const ProcurementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcurementApiFp(configuration)
    return {
        /**
         * 
         * @param {AddExistingCompanyToProcurementDto} addExistingCompanyToProcurementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerAddExistingCompanyToProcurement(addExistingCompanyToProcurementDto: AddExistingCompanyToProcurementDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.procurementControllerAddExistingCompanyToProcurement(addExistingCompanyToProcurementDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateProcurementSupplierDto} createProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerCreateProcurementSupplier(createProcurementSupplierDto: CreateProcurementSupplierDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.procurementControllerCreateProcurementSupplier(createProcurementSupplierDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} procurementSupplierId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerDeleteProcurementSupplier(procurementSupplierId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.procurementControllerDeleteProcurementSupplier(procurementSupplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [timezone] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerExportProcurementSuppliers(timezone?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.procurementControllerExportProcurementSuppliers(timezone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetBuyerCompanyName(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyNameDto> {
            return localVarFp.procurementControllerGetBuyerCompanyName(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetProcurementSupplierHubs(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcurementSupplierHubDto>> {
            return localVarFp.procurementControllerGetProcurementSupplierHubs(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string | null} [search] 
         * @param {string | null} [orderBy] 
         * @param {string | null} [orderDirection] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetProcurementSuppliers(search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcurementControllerGetProcurementSuppliers200Response> {
            return localVarFp.procurementControllerGetProcurementSuppliers(search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProcurementControllerGetSupplierReportsMetaDataFormBaseType} formBaseType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerGetSupplierReportsMetaData(formBaseType: ProcurementControllerGetSupplierReportsMetaDataFormBaseType, options?: RawAxiosRequestConfig): AxiosPromise<Array<FileMetaDataDto>> {
            return localVarFp.procurementControllerGetSupplierReportsMetaData(formBaseType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ImportProcurementSuppliersDto} importProcurementSuppliersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerImportProcurementSuppliers(importProcurementSuppliersDto: ImportProcurementSuppliersDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.procurementControllerImportProcurementSuppliers(importProcurementSuppliersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InviteProcurementSuppliersDto} inviteProcurementSuppliersDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerInviteProcurementSuppliers(inviteProcurementSuppliersDto: InviteProcurementSuppliersDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.procurementControllerInviteProcurementSuppliers(inviteProcurementSuppliersDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterProcurementSupplierDto} registerProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerRegisterProcurementSupplier(registerProcurementSupplierDto: RegisterProcurementSupplierDto, options?: RawAxiosRequestConfig): AxiosPromise<SupplierRegistrationStatusDto> {
            return localVarFp.procurementControllerRegisterProcurementSupplier(registerProcurementSupplierDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} procurementSupplierId 
         * @param {UpdateProcurementSupplierDto} updateProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerUpdateProcurementSupplier(procurementSupplierId: string, updateProcurementSupplierDto: UpdateProcurementSupplierDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.procurementControllerUpdateProcurementSupplier(procurementSupplierId, updateProcurementSupplierDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateProcurementSupplierDto} validateProcurementSupplierDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        procurementControllerValidateProcurementSupplier(validateProcurementSupplierDto: ValidateProcurementSupplierDto, options?: RawAxiosRequestConfig): AxiosPromise<CompanyBasicDto> {
            return localVarFp.procurementControllerValidateProcurementSupplier(validateProcurementSupplierDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProcurementApi - object-oriented interface
 * @export
 * @class ProcurementApi
 * @extends {BaseAPI}
 */
export class ProcurementApi extends BaseAPI {
    /**
     * 
     * @param {AddExistingCompanyToProcurementDto} addExistingCompanyToProcurementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerAddExistingCompanyToProcurement(addExistingCompanyToProcurementDto: AddExistingCompanyToProcurementDto, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerAddExistingCompanyToProcurement(addExistingCompanyToProcurementDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateProcurementSupplierDto} createProcurementSupplierDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerCreateProcurementSupplier(createProcurementSupplierDto: CreateProcurementSupplierDto, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerCreateProcurementSupplier(createProcurementSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} procurementSupplierId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerDeleteProcurementSupplier(procurementSupplierId: string, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerDeleteProcurementSupplier(procurementSupplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [timezone] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerExportProcurementSuppliers(timezone?: string, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerExportProcurementSuppliers(timezone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerGetBuyerCompanyName(companyId: string, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerGetBuyerCompanyName(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerGetProcurementSupplierHubs(options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerGetProcurementSupplierHubs(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string | null} [search] 
     * @param {string | null} [orderBy] 
     * @param {string | null} [orderDirection] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerGetProcurementSuppliers(search?: string | null, orderBy?: string | null, orderDirection?: string | null, pageNumber?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerGetProcurementSuppliers(search, orderBy, orderDirection, pageNumber, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProcurementControllerGetSupplierReportsMetaDataFormBaseType} formBaseType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerGetSupplierReportsMetaData(formBaseType: ProcurementControllerGetSupplierReportsMetaDataFormBaseType, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerGetSupplierReportsMetaData(formBaseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ImportProcurementSuppliersDto} importProcurementSuppliersDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerImportProcurementSuppliers(importProcurementSuppliersDto: ImportProcurementSuppliersDto, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerImportProcurementSuppliers(importProcurementSuppliersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InviteProcurementSuppliersDto} inviteProcurementSuppliersDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerInviteProcurementSuppliers(inviteProcurementSuppliersDto: InviteProcurementSuppliersDto, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerInviteProcurementSuppliers(inviteProcurementSuppliersDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterProcurementSupplierDto} registerProcurementSupplierDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerRegisterProcurementSupplier(registerProcurementSupplierDto: RegisterProcurementSupplierDto, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerRegisterProcurementSupplier(registerProcurementSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} procurementSupplierId 
     * @param {UpdateProcurementSupplierDto} updateProcurementSupplierDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerUpdateProcurementSupplier(procurementSupplierId: string, updateProcurementSupplierDto: UpdateProcurementSupplierDto, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerUpdateProcurementSupplier(procurementSupplierId, updateProcurementSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateProcurementSupplierDto} validateProcurementSupplierDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProcurementApi
     */
    public procurementControllerValidateProcurementSupplier(validateProcurementSupplierDto: ValidateProcurementSupplierDto, options?: RawAxiosRequestConfig) {
        return ProcurementApiFp(this.configuration).procurementControllerValidateProcurementSupplier(validateProcurementSupplierDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ProcurementControllerGetSupplierReportsMetaDataFormBaseType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13
} as const;
export type ProcurementControllerGetSupplierReportsMetaDataFormBaseType = typeof ProcurementControllerGetSupplierReportsMetaDataFormBaseType[keyof typeof ProcurementControllerGetSupplierReportsMetaDataFormBaseType];
